import { mandatory, nonMandatory } from '../storeFromRequestParamsValidation';


// TODO: add tests
export const createPathWithExtension = (path: string | undefined, extension: string | undefined) => {
  if (!path || !extension) {
    return null;
  }
  return `${path}.${extension}`;
};

export const createImage = (host: string, aspectRatio?: object) => (image: any) => {
    const path = mandatory(image.path, '');
    const fileExtension = mandatory(image.fileExtension, '');
    return {
        host: mandatory(host, ''),
        path: createPathWithExtension(path, fileExtension),
        credit: nonMandatory(image.credit),
        caption: nonMandatory(image.caption),
        description: nonMandatory(image.description),
        ...aspectRatio ? { aspectRatio } : {},
    };
};

export const createCoverVideo = (media: any) => {
    const type = nonMandatory(media.type);
    if (type === 'youtube') {
      return {
        html: nonMandatory(media.value.html),
        mediaId: nonMandatory(media.value.mediaId),
        type,
      };
    }
    if (type === 'mmPlayer') {
        return {
            html: mandatory(media.value.html, ''),
            mediaId: mandatory(media.value.mediaId, ''),
            playerId: mandatory(media.value.playerId, ''),
            type,
        };
    }
    if (type === 'jw') {
      return {
        html: mandatory(media.value.html, ''),
        videoId: mandatory(media.value.videoId, ''),
        playerId: mandatory(media.value.playerId, ''),
        type,
      };
    }
    return null;
};

export const createAuthor = (author: any) => {
  return {
    name: mandatory(author.name, ''),
    link: nonMandatory(author.link),
  };
};

export const createAuthors = (hideOwner: boolean) => (authors: any) => {
  const additionalAuthors = nonMandatory(authors.additional);
  const owner = mandatory(authors.owner, null);
  return [
    ...((hideOwner || !owner) ? [] : [owner]),
    ...(additionalAuthors || []),
  ].map(createAuthor);
};

const removeSeconds = (time: string) => time.replace(/:\d+\s/gi, ' ');

export const createShortDateOrTime = (midnightInTimeZoneISO: string, timeZone: string, locale: string) => (articleDateISO: string) => {
    const articleDate = Date.parse(articleDateISO);
    const midnightInTimeZone = Date.parse(midnightInTimeZoneISO);
    const TIME_WITH_SHORT_OFFSET = {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short',
    };
    const DATE_MED = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };
    const time = removeSeconds(Intl.DateTimeFormat(locale, { timeZone, ...TIME_WITH_SHORT_OFFSET }).format(articleDate));
    const date = Intl.DateTimeFormat(locale, { timeZone, ...DATE_MED }).format(articleDate);
    return articleDate >= midnightInTimeZone ? time : date;
};

export const createArticles = (imagesHost: any, midnightInTimeZoneISO: string, timeZone: string, locale: string) => (articles: Array<any>) => {
    return articles.map(article => {
    const hideOwner = nonMandatory(article.metadata.hideOwner);
        return {
            id: mandatory(article.id, ''),
            title: mandatory(article.title, ''),
            image: mandatory(article.cover.image.value, {}, createImage(imagesHost)),
            coverType: mandatory(article.coverType, ''),
            articleUrl: mandatory(article.articleUrl, ''),
            author: mandatory(article.author, '', createAuthor),
            createdAt: mandatory(article.createdAt, '', createShortDateOrTime(midnightInTimeZoneISO, timeZone, locale)),
            updatedAt: mandatory(article.updatedAt, '', createShortDateOrTime(midnightInTimeZoneISO, timeZone, locale)),
            featuredAt: mandatory(article.featuredAt, ''),
            authors: mandatory(article.authors, [], createAuthors(hideOwner)),
            description: mandatory(article.seoDescription, ''),
            mainCategory: '',
        };
    });
};
